﻿export class Color {
    static splitArgb(argb) {
        return [
            '#' + argb.substring(3, 9),
            argb.substring(1, 3)
        ];
    }

    static toHex(s: string) {
        var elements = s.split('(')[1].split(')')[0].split(',');
        return '#'
            + Color.toHexPair(+elements[0])
            + Color.toHexPair(+elements[1])
            + Color.toHexPair(+elements[2]);
    }

    private static toHexPair(s: number) {
        var hex = s.toString(16).toUpperCase();
        return hex.length === 1 ? '0' + hex : hex;
    }

    static applyBackground($element: JQuery, argb: string) {
        if (argb === null || argb === undefined || argb === '#00FFFFFF') {
            $element.css('background-color', '');
            return;
        }

        const parts = Color.splitArgb(argb);
        const transparency = parseInt(parts[1], 16);
        const opacity = transparency / 255;
        $element.css('background-color', parts[0]).css('opacity', opacity);
    }
}